import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const BASE = `${API_URL}/api/scanprompts`;

export const GET_SCAN_PROMPTS = '@scanprompt/list';
export const SAVE_SCAN_PROMPT = '@scanprompt/save';

/** Like the report job actions, these return the axios data so the screen can react to the outcome. */

export function getScanPrompts() {
  return async (dispatch) => {
    const response = await axios.get(BASE);
    dispatch({ type: GET_SCAN_PROMPTS, payload: response.data });
    return response.data;
  };
}

/** `version` is the version the editor loaded; the API rejects a stale one with 409. */
export function saveScanPrompt(provider, prompt, version) {
  return async (dispatch) => {
    const response = await axios.put(`${BASE}/${provider}`, { prompt, version });
    dispatch({ type: SAVE_SCAN_PROMPT, payload: response.data });
    return response.data;
  };
}

/** Earlier revisions, newest first. Not kept in the store: it is only read when the panel is opened. */
export function getScanPromptHistory(provider) {
  return async () => {
    const response = await axios.get(`${BASE}/${provider}/history`);
    return response.data.history;
  };
}
